export interface MixInput { key: 'suki' | 'bbq' | 'unattributed'; value: number; }
export interface MixSegment extends MixInput {
  /**
   * Label percentage. Brand segments use the ATTRIBUTED denominator
   * (suki+bbq) — the same math as the backend's
   * bbq_pct_of_attributed_sales (spec §3.4 + the ฿21.0M/17.7% label example).
   * The ไม่ระบุ segment reports its share of the TOTAL.
   */
  percent: number;
  /** Render width over the TOTAL denominator so the bar visually sums to 100%. */
  width: number;
}

/**
 * Decompose a sales_mix into share-bar segments.
 *
 * Two denominators, deliberately: the spec defines brand shares on
 * attributed sales only (unknown/9999 sales must not dilute BBQ's share),
 * while the stacked bar itself must span 100% of rendered width including
 * the gray ไม่ระบุ segment. When unattributed is zero both coincide.
 */
export function mixSegments(mix: { suki_net_total: number; bbq_net_total: number; unattributed_net_total: number }): MixSegment[] {
  const suki = Math.max(0, mix.suki_net_total);
  const bbq = Math.max(0, mix.bbq_net_total);
  const unattributed = Math.max(0, mix.unattributed_net_total);
  const attributed = suki + bbq;
  const total = attributed + unattributed;
  if (total === 0) return [];

  const segments: MixSegment[] = [];
  const push = (key: MixInput['key'], value: number, labelPct: number) => {
    if (value <= 0) return;
    segments.push({ key, value, percent: labelPct, width: value / total * 100 });
  };

  push('suki', suki, attributed > 0 ? suki / attributed * 100 : 0);
  push('bbq', bbq, attributed > 0 ? bbq / attributed * 100 : 0);
  push('unattributed', unattributed, unattributed / total * 100);
  return segments;
}
